import React, { useState } from 'react';
import { MaterialReactTable, type MRT_ColumnDef } from 'material-react-table';
import { Box, CircularProgress, Typography, useTheme } from '@mui/material';
import { useGetConstructionVarianceDriversQuery } from "store/slices/apis/constructionDashboardSlice ";
import { useParams } from 'react-router-dom';
import dayjs from 'dayjs';

type Person = {
  //sno: string;
  activity: string;
  baselineDate: string;
  forecastCompletionDate: string;
  varianceInDays: string;
  subCateogary1: string;
  subCateogary2: string;
  subCateogary3: string;
};

const columns: MRT_ColumnDef<Person>[] = [
  // { accessorKey: 'sno', header: 'S No.' },
  { accessorKey: 'activity', header: 'Critical Activities', muiTableHeadCellProps: { align: 'center' }, muiTableBodyCellProps: { align: 'center', sx: { whiteSpace: 'nowrap' }, }, },
  { accessorKey: 'baselineDate', header: 'Baseline', muiTableHeadCellProps: { align: 'center' }, muiTableBodyCellProps: { align: 'center' }, },
  { accessorKey: 'forecastCompletionDate', header: 'Forecast', muiTableHeadCellProps: { align: 'center' }, muiTableBodyCellProps: { align: 'center' }, },
  { accessorKey: 'varianceInDays', header: 'Variance', muiTableHeadCellProps: { align: 'center' }, muiTableBodyCellProps: { align: 'center' }, },
  { accessorKey: 'subCateogary1', header: 'Category', muiTableHeadCellProps: { align: 'center' }, muiTableBodyCellProps: { align: 'center' }, },
  { accessorKey: 'subCateogary2', header: 'Sub Category 1', muiTableHeadCellProps: { align: 'center' }, muiTableBodyCellProps: { align: 'center' }, },
  { accessorKey: 'subCateogary3', header: 'Sub Category 2', muiTableHeadCellProps: { align: 'center' }, muiTableBodyCellProps: { align: 'center' }, },
];

// Format helper
const formatDate = (dateString?: string) =>
  dateString ? dayjs(dateString).format('DD/MM/YY') : '';

// Flatten formatter (no children)
const formatScheduleData = (data: any[]): Person[] =>
  data.map((item) => ({
    // sno: item.sno,
    activity: item.activity,
    baselineDate: formatDate(item.baselineDate),
    forecastCompletionDate: formatDate(item.forecastCompletionDate),
    varianceInDays: item.varianceInDays,
    subCateogary1: item.subCateogary1,
    subCateogary2: item.subCateogary2,
    subCateogary3: item.subCateogary3,
  }));

export default function ConstuctionVarianceTable() {
  const [selectedMonth, setSelectedMonth] = useState("2025-05-01");
  const newtheme = useTheme();
  const { projectId } = useParams();
  const { data, isLoading, error } = useGetConstructionVarianceDriversQuery({ projectId, month: selectedMonth });

  const dataval: Person[] = data ? formatScheduleData(data) : [];

  return (
    <Box sx={{ mt: 1, width: "100%", borderRadius: "12px", overflow: "hidden", backgroundColor: "#fff", }} id="construction-variance-drivers">
      <Box sx={{ backgroundColor: "#fff", p: 2 }}>
        <Typography variant="h6" sx={{ fontWeight: 500, fontSize: "18px", color: `${newtheme?.customSettings?.themeColor}` }}>
          Variance Drivers Of Critical Activities
        </Typography>
        <Typography sx={{ color: "#666" }}>
          Identifying schedule variances in critical activities to enable targeted mitigation and control
        </Typography>
      </Box>
      {isLoading ? (
        <Box display="flex" justifyContent="center" mt={4} pb={1}>
          <CircularProgress />
        </Box>
      ) : error ? (
        <Typography color="error">Failed to load data.</Typography>
      ) : (
        <MaterialReactTable
          columns={columns}
          data={dataval}
          enableRowNumbers
          rowNumberDisplayMode="static"
          displayColumnDefOptions={{
            'mrt-row-numbers': {
              header: 'S No',
              size: 100,
              muiTableHeadCellProps: { align: 'center' },
              muiTableBodyCellProps: { align: 'center' },
            },
          }}
          muiTableHeadCellProps={{
            sx: {
              fontWeight: 500,
              fontSize: "14px",
              color: "#505258",
              padding: "10px 14px",
              backgroundColor: "#F8F8F8",
              border: "1px solid #D8D8D8",
            },
          }}
          muiTableBodyRowProps={{
            sx: {
              fontWeight: 400,
              fontSize: "14px",
              color: "#505258",
              padding: "10px 14px",
              backgroundColor: "#FFFFFF",
              border: "1px solid #D8D8D8",
              opacity: "0.54"
            },
          }}
          enableExpanding={false}
          enableRowSelection={false}
          enableFullScreenToggle={false}
        />
      )}
    </Box>
  );
}